import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import React from 'react';
import { v4 } from 'uuid';
import {
  BarcodeExportConfigurationContext,
  BarcodeExportConfigurationContextProps,
} from '../context/BarcodeExportConfigurationContext';
import { BarcodeExportConfiguration } from '../types/barcode_export_configuration';
import { useAppDispatch, useAppSelector } from '../ui/pages/store';

const barcodeExportConfigurationState = {
  items: new Map<string, BarcodeExportConfiguration>(),
  loading: false,
};

export const barcodeExportConfigurationSlice = createSlice({
  name: 'barcodeExportConfiguration',
  initialState: { key: v4() },
  reducers: {
    reset: state => {
      barcodeExportConfigurationState.items = new Map();
      barcodeExportConfigurationState.loading = true;
      state.key = v4();
    },
    set: (state, action: PayloadAction<BarcodeExportConfiguration[]>) => {
      barcodeExportConfigurationState.items = new Map();
      action.payload.forEach((p: BarcodeExportConfiguration) =>
        barcodeExportConfigurationState.items.set(p.id, new BarcodeExportConfiguration(p)),
      );
      state.key = v4();
    },
    add: (state, action: PayloadAction<BarcodeExportConfiguration[]>) => {
      action.payload.forEach((p: BarcodeExportConfiguration) =>
        barcodeExportConfigurationState.items.set(p.id, new BarcodeExportConfiguration(p)),
      );
      barcodeExportConfigurationState.items = new Map(barcodeExportConfigurationState.items);
      state.key = v4();
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      barcodeExportConfigurationState.loading = action.payload;
      state.key = v4();
    },
  },
});

interface BarcodeExportConfigurationProvider {
  children: React.ReactNode;
}

export default function BarcodeExportConfigurationProvider({ children }: BarcodeExportConfigurationProvider) {
  const dispatch = useAppDispatch();
  const key = useAppSelector(state => state.barcodeExportConfigurations.key);

  const context: BarcodeExportConfigurationContextProps = {
    barcodeExportConfigurations: barcodeExportConfigurationState.items,
    barcodeExportConfigurationsLoading: barcodeExportConfigurationState.loading,
    setBarcodeExportConfigurations: (bec: Map<string, BarcodeExportConfiguration>) => {
      dispatch(barcodeExportConfigurationSlice.actions.set([...bec.values()]));
    },
  };

  return (
    <BarcodeExportConfigurationContext.Provider value={context}>{children}</BarcodeExportConfigurationContext.Provider>
  );
}
